export default __webpack_public_path__ + "static/media/JointRelief500x900.ac069abf.jpg";